import ComingSoon from "@/pages/ComingSoon";

export default function Merch() {
  return (
    <ComingSoon
      testId="merch-page"
      chapter="Archive · Merch"
      title="Merch"
      blurb="Objects pulled from the worlds. Cut in small numbers, released without much warning. Wait here."
    />
  );
}
